import { render, staticRenderFns } from "./question-repo.vue?vue&type=template&id=4ee6bd09&"
import script from "./question-repo.vue?vue&type=script&lang=js&"
export * from "./question-repo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports